const app = angular.module('msi.shipments.changeShipmentDate', [
  require('./change-shipment-date.controller')
]);

app.component('ogChangeShipmentDateButton', require('./change-shipment-date-button'));
app.controller('ShipmentDateSelectController', require('./shipment-date-select.controller'));

module.exports = app.name;
